import type { AirportTaf } from '@/types/domain/core';
import { coreRequestService } from '@/api/core';

export const airportsIdTafGet = (id: number) => coreRequestService<AirportTaf>({
    url: `/airports/${id}/taf`,
    method: 'GET'
});
